import type { WorkflowType } from '@this/domain/organization/organization2';
import React from 'react';
import {
  SubSection,
  SubSectionTitle
} from '@this/components/organization/setting/workflow_setting_section/shared';
import WorkflowSection from '@this/components/organization/setting/workflow_setting_section/workflow_section';

interface DomesticFlightSectionProps {
  domesticFlightWorkflowType: WorkflowType;
  domesticFlightBufferAmount: number;
  handleChangeWorkflowType: (type: WorkflowType, target: string) => void;
  handleChangeBufferAmount: (amount: number, target: string) => void;
}

const DomesticFlightSection: React.FC<DomesticFlightSectionProps> = ({
  domesticFlightWorkflowType,
  domesticFlightBufferAmount,
  handleChangeWorkflowType,
  handleChangeBufferAmount
}) => {
  return (
    <SubSection>
      <SubSectionTitle>国内航空券</SubSectionTitle>

      <WorkflowSection
        description=""
        itemLabel="航空券"
        workflowType={domesticFlightWorkflowType}
        bufferAmount={domesticFlightBufferAmount}
        target="domesticFlight"
        onChangeWorkflowType={handleChangeWorkflowType}
        onChangeBufferAmount={handleChangeBufferAmount}
      />
    </SubSection>
  );
};

export default DomesticFlightSection;
